import React from "react";
import MainLayout from "../../components/layout/MainLayout";

// Return and Shipping Policy content component
const ShippingReturnPolicyContent = () => {
  return (
    <div className="w-full bg-guru-floral-white py-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm overflow-hidden">
        {/* Header banner with icon */}
        <div className="w-full bg-amber-50 py-6 px-8">
          <div className="flex items-center">
            <div className="mr-6 w-20 h-20 bg-amber-600 rounded-md flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-12 h-12">
                <path d="M19.15 8a2 2 0 0 0-1.72-1H15V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h2a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1v-5.69A2 2 0 0 0 19.15 8zM8 18a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm8 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm3-3h-.78a3 3 0 0 0-4.44 0H9.22a3 3 0 0 0-4.44 0H5v-8h8v1h-6a1 1 0 0 0 0 2h8.24l3.76 3z"></path>
              </svg>
            </div>
            <h1 className="text-3xl font-bold text-gray-800">送貨及退貨政策</h1>
          </div>
        </div>

        {/* Content area */}
        <div className="w-full p-8">
          <div className="text-gray-700">
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-indigo-700">關於送貨</h2>
              <ol className="list-decimal pl-5 space-y-4">
                <li>
                  顧客登記成為會員後，香港、九龍及新界區消費滿$450(以折扣後結帳金額計算)免運費送貨上門。
                  <p className="font-bold mt-2 text-red-600">⚠️個order不論有無凍貨，都一定會成張單嘅貨一齊送⚠️</p>
                  <p className="mt-1">(如有選購「預購」貨品，除非特別通知，否則成張單既貨一定會一齊送）</p>
                </li>
                <li>馬灣，東涌，機場消費滿$450(以結帳金額計算)免運費送貨上門。</li>
                <li>送貨上門包括一般住宅或大廈，村屋，唐樓或未有升降機之大廈包送3層樓梯，3層以上每層$10(落單時請註明)</li>
                <li>
                  成功落單及付款後，2個工作天內會由司機專線57439696 Whatsapp或Signal聯絡時間送貨上門，一般會於7個工作天內送到府上*
                  <p className="font-bold mt-2 text-red-600">
                    ⚠️如貨品「急用」可以主動WhatsApp或Signal聯絡司機專線57439696，我哋會盡量安排⚠️
                  </p>
                  <p className="mt-1 italic">
                    *個別偏遠地區，例如石澳，赤柱，清水灣，淺水灣，深水灣，山頂等，有機會超過7個工作天送到，敬請見諒
                  </p>
                </li>
                <li>送貨上門服務工作天為星期一至六，1000-2200</li>
                <li>離島，大嶼山，愉景灣，及車輛禁區不設送貨服務。</li>
                <li>
                  如送貨地址屬危險地方，為保障運輸同事安全，瓹窿瓹罅有權取消該訂單，而顧客不得提出訴訟及索償或追討任何賠償。
                  <p className="font-bold mt-2 text-red-600">
                    ⚠️如因節日或推廣活動太多訂單, 有機會超過7日送貨, 司機會盡早聯絡通知.
                    如貨品「急用」可以主動WhatsApp或Signal聯絡司機專線57439696，我哋會盡量安排, 多謝體晾🙇 ⚠️
                  </p>
                </li>
              </ol>

              <div className="mt-6 p-4 bg-amber-50 rounded-lg border border-amber-200">
                <p className="font-bold mb-2 text-amber-800">
                  🥺瓹窿瓹罅免運費送貨上門，只需要$300，而且無限制重量或數量，要做到7個工作天內送到，除咗靠運輸團隊每日做足12個鐘，其實都好需要大家體晾及配合.
                </p>
                <p className="font-bold text-amber-800">
                  大家都係真．香港人，明白大家都要返工要搵食，唔會長期有人係屋企.
                  但都希望體晾運輸哥哥佢地，大家互相遷就一下送貨時間，多謝大家支持🙏
                </p>
              </div>
            </div>

            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-indigo-700">關於退貨</h2>
              <ol className="list-decimal pl-5 space-y-4">
                <li>當您的訂單完成付款後，相關訂單內容已經被瓹窿瓹罅確認，除特別情況外，我們無法為您取消訂單內容。</li>
                <li>
                  如因運送過程導致外包裝損毀(產品本身未受損壞)，以及「義賣」及「唔准嘥嘢」專區之貨品，恕不接受任何退款或退貨要求。
                </li>
                <li>
                  如因運送過程導致產品本身受到損壞(「義賣」及「唔准嘥嘢」專區之貨品除外)，請於收貨後24小內連同貨品相片通知我們，顧客可透過打雜Signal或WhatsApp專線聯絡我們，我們收到通知後會盡快回覆及處理相關問題。
                </li>
                <li>顧客在收到貨品後有責任點算貨品是否齊全，到貨24小時後一律不接受任何追討事宜。</li>
                <li>除特別情況外，所有退款會以Guru Dollar(購物金)方式退還給顧客。</li>
                <li>如顧客於「唔准嘥嘢」專區購買任何產品，顧客需自行承擔一切因產品引起之後果。</li>
              </ol>
            </div>

            <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
              <p className="mb-2 font-medium">聯絡方式：</p>
              <p className="mb-1">送貨WhatsApp/Signal專線：57439696</p>
              <p className="mb-4">打雜WhatsApp/Signal專線：57448696</p>
              <p>瓹窿瓹罅致力為香港人服務，如有任何意見歡迎隨時反映，我們願意虛心學習，與香港一起進步!!</p>
            </div>

            <div className="mt-10 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
              <p className="mb-2">食物製造廠牌照號碼：2997813218</p>
              <p>最後更新日期：2025年3月11日</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main component (simplified to take full width but with centered content)
const Main = () => {
  return (
    <div className="w-full bg-guru-floral-white">
      <ShippingReturnPolicyContent />
    </div>
  );
};

// Page component
export default function ShippingReturnPolicyPage() {
  return (
    <MainLayout title="送貨及退貨政策 | GuruGuruHK" url="/article/shipping-return-policy">
      <Main />
    </MainLayout>
  );
}
